<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
<div>
  <div style="display: block;margin-top: 90px" >
    <img src="../assets/images/blog.png"  width="100%" />
  </div>
  <section class="blog-dispaly">
    <el-row type="flex" align="middle" style="padding:0 4%">
      <el-col :span=24>
        <ul class="blog-list">
          <li  v-for="(item, index) in blogDetail" :key="index">
            <a @click="handleBlog(item.addr)">
            <div class="li-content">
            <blog-slot>
              <template v-slot:image>
                <img :src="item.url" />
              </template>
              <template v-slot:date>
                <p>{{item.date}}</p>
              </template>
              <template v-slot:title>
                <h3>{{item.title}}</h3>
              </template>
              <template v-slot:abstract>
                <p>{{item.abs}}</p>
              </template>
            </blog-slot>
            </div>
            </a>
          </li>
        </ul>
      </el-col>
    </el-row>
  </section>
  <el-dialog
    title="文章展示"
    :visible.sync="blogVisible"
    width="820px"
    custom-class="el-dialog">
    <iframe width="100%" height="700px" :src="html"></iframe>
    <span slot="footer" class="dialog-footer">
    <el-button @click="blogVisible = false">取 消</el-button>
    <el-button type="primary" @click="blogVisible = false">确 定</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
import articles from './blog/blog.json'
import blogSlot from './blog/blog-card'
export default {
  name: 'blog',
  components: {
    blogSlot
  },
  data () {
    return {
      blogVisible: false,
      blogDetail: null,
      html: ''
    }
  },
  methods: {
    handleBlog (obj) {
      this.blogVisible = true
      this.html = 'static/blog/' + obj + '.html'
      this.html = obj
      // alert(this.html)
      // console.log(obj)
    }
  },
  mounted () {
    this.blogDetail = articles.articles.reverse()
    // console.log(this.blogDetail)
  }
}
</script>

<style scoped>
  .blog-list{
    padding-top: 50px;
    padding-left: 12em;
    //padding-right: 5em;
    margin: auto;
    //float: left;
    //list-style: none;
    //width: 90%;
  }
  .blog-list li{
    float: left;
    list-style: none;
  }
  .blog-list li:nth-child(3n+1){
    clear: both;
  }
  .blog-list li a{
    //display: block;
    text-decoration: none;
  }

  .li-content{
    //padding: 15px;
    background-color: #f5f7fa;
  }
  .li-content:after{
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4px;
    background: #20d34a;
    content: '';
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
 .li-content:hover{

    /*display: block;*/
    /*margin: auto;*/
    /*padding: auto;*/
    /*//width: 90%;*/
    /*//height: 90%;*/
    /*border: 2px solid crimson;*/
    /*cursor: pointer;*/
    /*z-index: 100;*/
   background: #9fcdff;
 }
  .li-content:hover::after
  {
    visibility: visible;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/blog.vue